import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_DISCARD } from "./gql";

const useDiscardRun = createDefaultMutationHook(RUN_DISCARD);
export const useBulkDiscardRun = createBulkMutationHook(RUN_DISCARD);

export default useDiscardRun;
